<template>
  <common-modal-section class="check-in-failed-modal-section" @close="emitClose">
    <template v-slot:default>
      <modal-title-parts :title="$tc('MissionPage.checkIn.errors.outOfAreaOrPeriod.title')" />
      <modal-message-parts :message="$tc('MissionPage.checkIn.errors.outOfAreaOrPeriod.message')" />
      <div class="check-in-failed-modal-section__external-link">
        <atom-link
          :url="currentLocationGoogleMapUrl"
          :linkText="$tc('MissionPage.checkIn.errors.outOfAreaOrPeriod.checkGoogleMap')"
          :imgPath="require('@/assets/img/icon/icon_external_link_outline.svg')"
          :iconPosition="'right'"
        />
      </div>
      <modal-message-parts
        class="check-in-failed-modal-section__code"
        :message="$tc('MissionPage.checkIn.errors.outOfAreaOrPeriod.code')"
      />
      <modal-message-parts
        class="check-in-failed-modal-section__current-location"
        :message="displayCurrentLocation"
      />
    </template>

    <template v-slot:buttons>
      <atom-input-button
        :linkText="$tc('common.ok')"
        colorType="secondary"
        :isDisabled="false"
        @push="emitClose()"
      />
    </template>
  </common-modal-section>
</template>

<script lang="ts">
import { defineComponent, computed } from '@vue/composition-api'
import CommonModalSection from '@/components/common/modal/CommonModalSection.vue'
import ModalTitleParts from '@/components/common/modal/parts/ModalTitleParts.vue'
import ModalMessageParts from '@/components/common/modal/parts/ModalMessageParts.vue'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'
import AtomLink from '@/components/atoms/AtomLink.vue'
import Const from '@/util/Const'
import I18n from '@/locales/I18n'
import StoreUtil from '@/store/StoreUtil'

/**
 * ミッション画面 チェックイン失敗モーダル
 */
export default defineComponent({
  name: 'CheckInFailedModalSection',
  components: {
    AtomLink,
    CommonModalSection,
    ModalTitleParts,
    ModalMessageParts,
    AtomInputButton,
  },
  props: {
    link: {
      type: String,
      default: '',
    },
  },
  setup() {
    const missionPageStore = StoreUtil.useStore('MissionPageStore')
    const { currentLocationInfo } = missionPageStore

    /** 現在地のGoogle Mapのリンク */
    const currentLocationGoogleMapUrl = computed(() => {
      const googleMapUrl =
        I18n.locale === 'ja' ? Const.EXTERNAL_LINKS.GOOGLE_MP.JA : Const.EXTERNAL_LINKS.GOOGLE_MP.EN
      return `${googleMapUrl}&ll=${currentLocationInfo.value?.lat},${currentLocationInfo.value?.lng}`
    })

    const displayCurrentLocation = computed(() =>
      I18n.t('MissionPage.checkIn.errors.outOfAreaOrPeriod.currentLocation', {
        lat: currentLocationInfo.value?.lat,
        lng: currentLocationInfo.value?.lng,
      }).toString(),
    )

    return {
      currentLocationGoogleMapUrl,
      displayCurrentLocation,
    }
  },
  methods: {
    emitClose(): void {
      /**
       * closeModal
       * 親コンポーネントへ閉じる処理を通知
       */
      this.$emit('close')
    },
  },
})
</script>

<style lang="scss" scoped>
.check-in-failed-modal-section {
  color: $gray75;
  text-align: center;

  &__code {
    margin-top: 6px;
  }

  &__current-location {
    margin-top: 16px;
    @include fontSetTextSmall();
  }
}
</style>
